import React from 'react';
import { GraficaBarras } from './Grafica';
import { MenuPublico } from './MenuPublico';
import { Grid } from '@mui/material';


const HomePage: React.FC = () => {
  return (
    <div className="main-content-wrapper">
      <MenuPublico selectedLink={0} />
      <div className="main-content">
        <div className="full-width-content"> {/* Nuevo contenedor */}
          <p className="bold-fullwidth-text"> {/* Nueva clase para el párrafo */}
            En el Poder Ejecutivo, la Secretaría de Finanzas y Tesorería General del Estado es la dependencia encargada
            de publicar la información de la distribución de recursos a los municipios, consulta aquí los documentos que
            contienen la información de la distribución de estos recursos.
          </p>
        </div>
        <GraficaBarras />
        <Grid container spacing={2}>
        {/* AÑO */}
        <Grid item xs={12}>
        <div className="button-container">
          <a href="https://www.nl.gob.mx/es/informacion-financiera" target="_blank" className="info-btn">Más información financiera</a>
        </div>
        </Grid>
        </Grid>
        
      </div>
    </div>
  );
};

export default HomePage;
 